import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';

import { IProgressState } from './IProgressSate';
import { CALCULATION_PROGRESS_RECEIVED, IMPORT_DATA_PROGRESS_RECEIVED, CLEAR_CALCULATION_PROGRESS_STATE, CLEAR_IMPORT_PROGRESS_STATE, CANCELED_IMPORT_PROGRESS_STATE, IMPORT_INSTRUMENTS_PROGRESS_RECEIVED, CLEAR_IMPORT_INSTRUMENTS_PROGRESS_STATE } from './progress.action.const';
import { NotificationProgressInfo } from '../../../core/server-notification/progress-notification.interfaces';
import { NotificationsService } from '../../../core/template/notifications/notifications.service';
import { IAppState } from '../../store/IAppState';

@Injectable()
export class ProgressAction {
    private completedImportRequests = {};
    readonly LARGE_NUMBER_ITEMS = 800;
    readonly STATUS_STOPPED = 'Stopped';

    constructor(private ngRedux: NgRedux<IAppState>,
        private uiNotificationsService: NotificationsService) {
    }

    calculationProgressReceived(notification: NotificationProgressInfo) {
        let message = `Calculating ${notification.totalItemsCount} Test(s) ${notification.percentageDone} %`;
        if (notification.totalItemsCount === 0) {
            message = `0 Test has been calculated.`;
        }
        const progress: IProgressState = this.ngRedux.getState().progressState;

        if (!this.ignoreProgress(progress.calculation.notification, notification)) {
            const payload = {
                id: notification.requestId,
                message,
                type: (notification.isDone) ? 'checked' : 'spinner'
            };

            this.uiNotificationsService.popUpMsg(payload);

            this.ngRedux.dispatch({
                type: CALCULATION_PROGRESS_RECEIVED,
                payload: notification
            });
        }
    }

    clearCalculationProgressState() {
        this.ngRedux.dispatch({ type: CLEAR_CALCULATION_PROGRESS_STATE });
    }

    importDataProgressReceived(notification: NotificationProgressInfo, isLabImport: boolean) {
        if (!this.completedImportRequests[notification.requestId]) {
            const hasError = notification.status === this.STATUS_STOPPED;
            const hasEnded = notification.isDone || notification.isCanceled || hasError;

            // When complete, store flag to filter out any subsequent trailing messages.
            if (hasEnded) {
                this.completedImportRequests[notification.requestId] = true;
            }

            if ((notification.totalItemsCount < this.LARGE_NUMBER_ITEMS || notification.totalItemsDone % 50 === 0)
                || hasEnded) {
                let message = isLabImport ? 'Import of lab ' : 'Import of instrument ';
                
                if (notification.isProgressing) {
                    message += 'is in progress';
                } else if (notification.isCanceled) {
                    message += 'canceled';
                } else if (hasError) {
                    message += 'resulted in error';
                } else if (notification.isDone) {
                    message += 'completed';
                }

                let notificationType = 'none';
                if (!hasError && !notification.isCanceled)
                {
                    notificationType = (notification.isProgressing) ? 'spinner' : 'checked';
                }

                const payload = {
                    id: notification.requestId,
                    message,
                    type: notificationType
                };
                this.uiNotificationsService.popUpMsg(payload);

                if (isLabImport) {
                    this.ngRedux.dispatch({
                        type: IMPORT_DATA_PROGRESS_RECEIVED,
                        payload: notification
                    });
                } else {
                    this.ngRedux.dispatch({
                        type: IMPORT_INSTRUMENTS_PROGRESS_RECEIVED,
                        payload: notification
                    });
                }
            }
        }
    }

    clearImportDataProgressState() {
        this.ngRedux.dispatch({ type: CLEAR_IMPORT_PROGRESS_STATE });
    }

    cancelImportDataProgressState() {
        this.ngRedux.dispatch({ type: CANCELED_IMPORT_PROGRESS_STATE });
    }

    clearImportInstrumentProgressState() {
        this.ngRedux.dispatch({ type: CLEAR_IMPORT_INSTRUMENTS_PROGRESS_STATE });
    }

    private ignoreProgress(currentProgress: NotificationProgressInfo, incomingProgress: NotificationProgressInfo) {

        if (currentProgress && incomingProgress) {
            if (currentProgress.requestId === incomingProgress.requestId) {

                if (currentProgress.status === 'Canceled' || currentProgress.totalItemsDone >= incomingProgress.totalItemsDone) {
                    return true;
                }
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/progress/progress.action.ts